import gql from 'graphql-tag'

export const UPDATE_OPEN_POSITION_FOR_CLIENT = gql`
  mutation Sp_UpdateCurrPosValue($data: [Sp_UpdateCurrPosValueInput]) {
    Sp_UpdateCurrPosValue(data: $data)
  }
`
